const pre = '/UI/steps/'

export default {
  INIT: `${pre}INIT`,
  RESET: `${pre}RESET`,
  PREVIOUS_STEP: `${pre}PREVIOUS_STEP`,
  NEXT_STEP: `${pre}NEXT_STEP`,
  SET_STEP: `${pre}SET_STEP`
}
